module.exports = __webpack_public_path__ + "img/03.f282e082.jpg";